import { useEffect, useState } from "react";
import { isUsable } from "../../../helpers/functions";
import GaTracker from "../../../trackers/ga-tracker";

const TocPanel = ({ rendition, onGoto = () => {}, onSelect = () => {} }) => {
    const [tocItems, setTocItems] = useState([]);
    const [activeHref, setActiveHref] = useState("");

    useEffect(() => {
        if (!isUsable(rendition)) return;
        if (!isUsable(rendition.book)) return;
        rendition.book.loaded.navigation.then(({ toc }) => {
            const toc_ = toc.map((t) => ({ label: t.label, href: t.href }));
            setTocItems(toc_);
        });
    }, [rendition]);

    useEffect(() => {
        if (!isUsable(rendition)) return;

        const updateActiveHref = (location) => {
            const href = location?.start?.href;
            if (href) setActiveHref(href);
        };

        rendition.on("relocated", updateActiveHref);
        if (rendition.location) updateActiveHref(rendition.location);

        return () => rendition.off("relocated", updateActiveHref);
    }, [rendition]);

    const isActiveItem = (href) => {
        if (!activeHref || !href) return false;
        const normalize = (h) => h.replace(/^\.?\//, "");
        return normalize(activeHref) === normalize(href);
    };

    const renderTOCItems = () => {
        let domItems = [];
        if (!isUsable(rendition)) return "";
        tocItems.forEach((item, i) => {
            domItems.push(
                <div
                    key={i}
                    className={`panel__toc__item${isActiveItem(item.href) ? " panel__toc__item--active" : ""}`}
                    onClick={() => gotoTOCItem(`${item.href}`)}
                >
                    <div className="typo__body typo__body--1">{item.label}</div>
                </div>
            );
        });
        if (domItems.length === 0) domItems.push(<div key="empty" className="panel__empty">No Items</div>);
        return domItems;
    };

    const gotoTOCItem = (cfi) => {
        onSelect();
        GaTracker("event_toc_panel_goto");
        if (!isUsable(rendition)) return;
        rendition.display(cfi);
        rendition.display(cfi);
        onGoto();
    };

    return <div className="panel panel__toc">{renderTOCItems()}</div>;
};

export default TocPanel;
